export var TabName;
(function (TabName) {
    TabName["ACCOUNT_INFO"] = "Account Info";
    TabName["ADD_TEACHERS"] = "Add Teachers";
    TabName["ADD_STUDENTS"] = "Add Students";
    TabName["PAYMENT_INFO"] = "Payment Info";
})(TabName || (TabName = {}));
